// // src/pages/treatments/IVFFertilityPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const IVF_TREATMENT = {
//   slug: "ivf-fertility",
//   name: "IVF & Fertility Treatment",
//   shortName: "IVF & Fertility",
//   tagline: "Your Dream of Parenthood. Made Possible.",
//   heroSubtag:
//     "World-class fertility care at a fraction of Western costs. Personalised IVF protocols. Proven success rates.",
//   description:
//     "Comprehensive fertility care combining IVF, ICSI, egg donation, surrogacy support and advanced embryology under one roof. Our multidisciplinary reproductive medicine teams review every case to deliver globally benchmarked, personalised treatment plans with exceptional success rates.",
//   heroImage: "/IVF.jpeg",
//   category: "IVF & Fertility",
//   badge: "Advanced Reproductive Care",
//   accentColor: "pink",
//   costCard: {
//     label: "IVF treatment packages",
//     value: "₹1.2L–₹3.5L",
//     compare: "vs. £8,000–£15,000 in the UK",
//     stay: "Typically 3–4 weeks per IVF cycle",
//     stayCompare: "vs. $15,000–$30,000 in the US",
//   },
//   stats: [
//     { label: "Success Rate", value: "65%+", icon: Award },
//     { label: "Babies Delivered", value: "25,000+", icon: Users },
//     { label: "Years Experience", value: "20+", icon: Shield },
//     { label: "Avg. Cycle Time", value: "21 Days", icon: Clock },
//   ],
//   benefits: [
//     "Advanced IVF, ICSI, IMSI and time-lapse embryo monitoring",
//     "Preimplantation Genetic Testing (PGT-A, PGT-M) for healthy embryos",
//     "Egg freezing and embryo cryopreservation programmes",
//     "Donor egg, donor sperm and embryo donation services",
//     "Comprehensive hormonal and hysteroscopic assessment",
//     "Male fertility evaluation — sperm DNA fragmentation, TESA/PESA",
//     "Psychological counselling and fertility coaching throughout treatment",
//     "Recurrent implantation failure and recurrent miscarriage specialist clinics",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Fertility Assessment",
//       desc: "Complete hormonal profiling, antral follicle count, semen analysis and uterine evaluation.",
//       duration: "3–5 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Ovarian Stimulation",
//       desc: "Personalised stimulation protocol with daily monitoring ultrasounds and hormone adjustments.",
//       duration: "10–14 Days",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Egg Retrieval & Fertilisation",
//       desc: "Ultrasound-guided egg collection under sedation, followed by IVF or ICSI fertilisation in the embryology lab.",
//       duration: "1–2 Days",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Embryo Transfer & Support",
//       desc: "Blastocyst transfer on day 5, with two-week progesterone support and pregnancy confirmation test.",
//       duration: "2 Weeks",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "What is the success rate of IVF in India?",
//       a: "Leading Indian fertility centres report clinical pregnancy rates of 60–70% per cycle for women under 35 using own eggs, which is comparable to the best centres globally. Success rates vary based on age, diagnosis and embryo quality.",
//     },
//     {
//       q: "How many IVF cycles will I need?",
//       a: "Many patients conceive in the first cycle. However, depending on your diagnosis, age and embryo quality, two to three cycles may be recommended. Our embryo freezing programme means unused embryos can be used in future cycles at much lower cost.",
//     },
//     {
//       q: "Is egg donation available for older patients?",
//       a: "Yes. India has one of the most established donor egg programmes in the world. Our rigorously screened donor pool — matched by blood group, physical characteristics and genetic health — allows patients up to 50 years old to attempt pregnancy.",
//     },
//     {
//       q: "What does IVF in India cost compared to the UK or USA?",
//       a: "A complete IVF cycle in India typically costs ₹1.2L–₹2.5L (approximately $1,500–$3,000), compared to £8,000–£15,000 in the UK and $15,000–$30,000 in the USA — with equivalent or superior laboratory standards and success rates.",
//     },
//     {
//       q: "Can I travel home after embryo transfer?",
//       a: "Yes. Most patients travel home 2–3 days after embryo transfer. Your Indian clinic provides a detailed luteal support protocol and communicates directly with your home doctor. A blood pregnancy test (beta-HCG) is done locally 14 days after transfer.",
//     },
//     {
//       q: "Do you offer PGT (Preimplantation Genetic Testing)?",
//       a: "Yes. PGT-A (for chromosomal abnormalities) and PGT-M (for specific genetic diseases) are available. This is particularly valuable for patients with recurrent miscarriage or known hereditary conditions, and significantly improves implantation rates.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Nandita Palshetkar",
//       specialty: "Reproductive Medicine & IVF",
//       experience: "30 Years",
//       rating: 4.9,
//       reviews: 3200,
//       image: "https://randomuser.me/api/portraits/women/44.jpg",
//       qualifications: "MBBS, MD (OBG), FCPS, FICOG",
//       hospital: "Lilavati Hospital, Mumbai",
//     },
//     {
//       name: "Dr. Kamini Rao",
//       specialty: "IVF & Assisted Reproduction",
//       experience: "25 Years",
//       rating: 4.9,
//       reviews: 2800,
//       image: "https://randomuser.me/api/portraits/women/55.jpg",
//       qualifications: "MBBS, MS (OBG), DNB, FRCOG",
//       hospital: "Milann Fertility Centre, Bangalore",
//     },
//     {
//       name: "Dr. Srinivas Chakravarthy",
//       specialty: "Male Fertility & Andrology",
//       experience: "18 Years",
//       rating: 4.8,
//       reviews: 1450,
//       image: "https://randomuser.me/api/portraits/men/47.jpg",
//       qualifications: "MBBS, MS (Urology), MCh (Andrology)",
//       hospital: "Apollo Fertility, Chennai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Amina Hassan",
//       age: 36,
//       location: "Nairobi, Kenya",
//       text: "After 6 years of trying and two failed IVF cycles in Nairobi, PaxGrow arranged my treatment at a top Mumbai clinic. I am now 7 months pregnant with twins. The cost was less than half of what I spent previously.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/68.jpg",
//       treatment: "IVF with ICSI — Donor Egg",
//       date: "February 2024",
//     },
//     {
//       name: "Grace & Samuel Osei",
//       age: 34,
//       location: "Accra, Ghana",
//       text: "We had almost given up hope. The team in Bangalore found that my husband had severe sperm DNA fragmentation — something never tested at home. After TESA and ICSI, we had a healthy baby boy. We are forever grateful.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/82.jpg",
//       treatment: "TESA + ICSI for Male Factor Infertility",
//       date: "March 2024",
//     },
//     {
//       name: "Fatima Al-Rashidi",
//       age: 41,
//       location: "Dubai, UAE",
//       text: "I was told my only option was donor eggs. The genetic testing in India confirmed this, but the counselling and donor matching process was so thorough and compassionate. My daughter was born healthy in December.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/36.jpg",
//       treatment: "IVF with PGT-A — Donor Egg Programme",
//       date: "January 2024",
//     },
//   ],
// };

// const IVF_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African & Gulf Patients Choose India for IVF",
//   whyIndiaReasons: [
//     "NABH-accredited fertility centres with time-lapse embryoscopes, laser-assisted hatching and PGT-A genetic testing",
//     "Senior reproductive endocrinologists review every case — personalised protocols, not one-size-fits-all",
//     "Stimulation begins within 5 days of arrival — no 6-month waiting lists as in the UK or Canada",
//     "Apollo Fertility, Milann, Nova IVF, Cloudnine — globally ranked IVF success rates with full transparency",
//   ],
//   conditionsTitle: "Fertility Conditions We Facilitate Treatment For",
//   conditions: [
//     "Unexplained Infertility",
//     "Polycystic Ovary Syndrome (PCOS)",
//     "Blocked or Damaged Fallopian Tubes",
//     "Endometriosis",
//     "Low Ovarian Reserve (Low AMH)",
//     "Male Factor Infertility",
//     "Recurrent Miscarriage",
//     "Premature Ovarian Insufficiency",
//     "Failed IVF Cycles",
//     "Uterine Fibroids & Polyps",
//     "Azoospermia (TESA/PESA)",
//     "Single Women & LGBTQ+ Fertility",
//   ],
//   stayValue:
//     "Typically 21–28 days per IVF cycle; egg donation cycles may require 2 visits",
//   costTitle: "Why India for IVF & Fertility Treatment?",
//   costRows: [
//     {
//       procedure: "Standard IVF Cycle (own eggs)",
//       india: "₹1.2L–₹2.0L",
//       africa: "$4,000–$8,000",
//       ukusa: "$15,000–$25,000",
//     },
//     {
//       procedure: "IVF with ICSI",
//       india: "₹1.5L–₹2.5L",
//       africa: "$5,000–$9,000",
//       ukusa: "$18,000–$28,000",
//     },
//     {
//       procedure: "Donor Egg IVF Cycle",
//       india: "₹2.5L–₹4.0L",
//       africa: "Largely unavailable",
//       ukusa: "$30,000–$50,000",
//     },
//     {
//       procedure: "Embryo Freezing (per year)",
//       india: "₹20,000–₹40,000",
//       africa: "$1,500–$3,000",
//       ukusa: "$5,000–$10,000",
//     },
//     {
//       procedure: "Preimplantation Genetic Testing (PGT-A)",
//       india: "₹40,000–₹80,000",
//       africa: "Largely unavailable",
//       ukusa: "$6,000–$12,000",
//     },
//   ],
// };

// const IVFFertilityPage = () => {
//   return <TreatmentTemplate treatment={IVF_TREATMENT} paxgrowData={IVF_PAXGROW} />;
// };

// export default IVFFertilityPage;

// src/pages/treatments/IVFFertilityPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const IVF_TREATMENT = {
  slug: "ivf-fertility",
  name: "IVF & Fertility Treatment",
  shortName: "IVF & Fertility",
  tagline: "Your Dream of Parenthood. Made Possible.",
  heroSubtag:
    "World-class fertility care at a fraction of Western costs. Personalised IVF protocols. Proven success rates.",
  description:
    "Comprehensive fertility care combining IVF, ICSI, egg donation, surrogacy support and advanced embryology under one roof. Our multidisciplinary reproductive medicine teams review every case to deliver globally benchmarked, personalised treatment plans with exceptional success rates.",
  heroImage: "/IVF.jpeg",
  category: "IVF & Fertility",
  badge: "Advanced Reproductive Care",
  accentColor: "pink",
  costCard: {
    label: "IVF treatment packages",
    value: "$1,500–$4,200",
    compare: "vs. $10,000–$18,000 in the UK",
    stay: "Typically 3–4 weeks per IVF cycle",
    stayCompare: "vs. $15,000–$30,000 in the US",
  },
  stats: [
    { label: "Success Rate", value: "65%+", icon: Award },
    { label: "Babies Delivered", value: "25,000+", icon: Users },
    { label: "Years Experience", value: "20+", icon: Shield },
    { label: "Avg. Cycle Time", value: "21 Days", icon: Clock },
  ],
  benefits: [
    "Advanced IVF, ICSI, IMSI and time-lapse embryo monitoring",
    "Preimplantation Genetic Testing (PGT-A, PGT-M) for healthy embryos",
    "Egg freezing and embryo cryopreservation programmes",
    "Donor egg, donor sperm and embryo donation services",
    "Comprehensive hormonal and hysteroscopic assessment",
    "Male fertility evaluation — sperm DNA fragmentation, TESA/PESA",
    "Psychological counselling and fertility coaching throughout treatment",
    "Recurrent implantation failure and recurrent miscarriage specialist clinics",
  ],
  procedure: [
    {
      step: "01",
      title: "Fertility Assessment",
      desc: "Complete hormonal profiling, antral follicle count, semen analysis and uterine evaluation.",
      duration: "3–5 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Ovarian Stimulation",
      desc: "Personalised stimulation protocol with daily monitoring ultrasounds and hormone adjustments.",
      duration: "10–14 Days",
      icon: Activity,
    },
    {
      step: "03",
      title: "Egg Retrieval & Fertilisation",
      desc: "Ultrasound-guided egg collection under sedation, followed by IVF or ICSI fertilisation in the embryology lab.",
      duration: "1–2 Days",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Embryo Transfer & Support",
      desc: "Blastocyst transfer on day 5, with two-week progesterone support and pregnancy confirmation test.",
      duration: "2 Weeks",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "What is the success rate of IVF in India?",
      a: "Leading Indian fertility centres report clinical pregnancy rates of 60–70% per cycle for women under 35 using own eggs, which is comparable to the best centres globally. Success rates vary based on age, diagnosis and embryo quality.",
    },
    {
      q: "How many IVF cycles will I need?",
      a: "Many patients conceive in the first cycle. However, depending on your diagnosis, age and embryo quality, two to three cycles may be recommended. Our embryo freezing programme means unused embryos can be used in future cycles at much lower cost.",
    },
    {
      q: "Is egg donation available for older patients?",
      a: "Yes. India has one of the most established donor egg programmes in the world. Our rigorously screened donor pool — matched by blood group, physical characteristics and genetic health — allows patients up to 50 years old to attempt pregnancy.",
    },
    {
      q: "What does IVF in India cost compared to the UK or USA?",
      a: "A complete IVF cycle in India typically costs $1,500–$3,000, compared to $10,000–$18,000 in the UK and $15,000–$30,000 in the USA — with equivalent or superior laboratory standards and success rates.",
    },
    {
      q: "Can I travel home after embryo transfer?",
      a: "Yes. Most patients travel home 2–3 days after embryo transfer. Your Indian clinic provides a detailed luteal support protocol and communicates directly with your home doctor. A blood pregnancy test (beta-HCG) is done locally 14 days after transfer.",
    },
    {
      q: "Do you offer PGT (Preimplantation Genetic Testing)?",
      a: "Yes. PGT-A (for chromosomal abnormalities) and PGT-M (for specific genetic diseases) are available. This is particularly valuable for patients with recurrent miscarriage or known hereditary conditions, and significantly improves implantation rates.",
    },
  ],
  doctors: [
    {
      name: "Dr. Nandita Palshetkar",
      specialty: "Reproductive Medicine & IVF",
      experience: "30 Years",
      rating: 4.9,
      reviews: 3200,
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      qualifications: "MBBS, MD (OBG), FCPS, FICOG",
      hospital: "Lilavati Hospital, Mumbai",
    },
    {
      name: "Dr. Kamini Rao",
      specialty: "IVF & Assisted Reproduction",
      experience: "25 Years",
      rating: 4.9,
      reviews: 2800,
      image: "https://randomuser.me/api/portraits/women/55.jpg",
      qualifications: "MBBS, MS (OBG), DNB, FRCOG",
      hospital: "Milann Fertility Centre, Bangalore",
    },
    {
      name: "Dr. Srinivas Chakravarthy",
      specialty: "Male Fertility & Andrology",
      experience: "18 Years",
      rating: 4.8,
      reviews: 1450,
      image: "https://randomuser.me/api/portraits/men/47.jpg",
      qualifications: "MBBS, MS (Urology), MCh (Andrology)",
      hospital: "Apollo Fertility, Chennai",
    },
  ],
  testimonials: [
    {
      name: "Amina Hassan",
      age: 36,
      location: "Nairobi, Kenya",
      text: "After 6 years of trying and two failed IVF cycles in Nairobi, PaxGrow arranged my treatment at a top Mumbai clinic. I am now 7 months pregnant with twins. The cost was less than half of what I spent previously.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/68.jpg",
      treatment: "IVF with ICSI — Donor Egg",
      date: "February 2024",
    },
    {
      name: "Grace & Samuel Osei",
      age: 34,
      location: "Accra, Ghana",
      text: "We had almost given up hope. The team in Bangalore found that my husband had severe sperm DNA fragmentation — something never tested at home. After TESA and ICSI, we had a healthy baby boy. We are forever grateful.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/82.jpg",
      treatment: "TESA + ICSI for Male Factor Infertility",
      date: "March 2024",
    },
    {
      name: "Fatima Al-Rashidi",
      age: 41,
      location: "Dubai, UAE",
      text: "I was told my only option was donor eggs. The genetic testing in India confirmed this, but the counselling and donor matching process was so thorough and compassionate. My daughter was born healthy in December.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/36.jpg",
      treatment: "IVF with PGT-A — Donor Egg Programme",
      date: "January 2024",
    },
  ],
};

const IVF_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African & Gulf Patients Choose India for IVF",
  whyIndiaReasons: [
    "NABH-accredited fertility centres with time-lapse embryoscopes, laser-assisted hatching and PGT-A genetic testing",
    "Senior reproductive endocrinologists review every case — personalised protocols, not one-size-fits-all",
    "Stimulation begins within 5 days of arrival — no 6-month waiting lists as in the UK or Canada",
    "Apollo Fertility, Milann, Nova IVF, Cloudnine — globally ranked IVF success rates with full transparency",
  ],
  conditionsTitle: "Fertility Conditions We Facilitate Treatment For",
  conditions: [
    "Unexplained Infertility",
    "Polycystic Ovary Syndrome (PCOS)",
    "Blocked or Damaged Fallopian Tubes",
    "Endometriosis",
    "Low Ovarian Reserve (Low AMH)",
    "Male Factor Infertility",
    "Recurrent Miscarriage",
    "Premature Ovarian Insufficiency",
    "Failed IVF Cycles",
    "Uterine Fibroids & Polyps",
    "Azoospermia (TESA/PESA)",
    "Single Women & LGBTQ+ Fertility",
  ],
  stayValue:
    "Typically 21–28 days per IVF cycle; egg donation cycles may require 2 visits",
  costTitle: "Why India for IVF & Fertility Treatment?",
  costRows: [
    {
      procedure: "Standard IVF Cycle (own eggs)",
      india: "$1,500–$2,400",
      africa: "$4,000–$8,000",
      ukusa: "$15,000–$25,000",
    },
    {
      procedure: "IVF with ICSI",
      india: "$1,800–$3,000",
      africa: "$5,000–$9,000",
      ukusa: "$18,000–$28,000",
    },
    {
      procedure: "Donor Egg IVF Cycle",
      india: "$3,000–$4,800",
      africa: "Largely unavailable",
      ukusa: "$30,000–$50,000",
    },
    {
      procedure: "Embryo Freezing (per year)",
      india: "$250–$500",
      africa: "$1,500–$3,000",
      ukusa: "$5,000–$10,000",
    },
    {
      procedure: "Preimplantation Genetic Testing (PGT-A)",
      india: "$500–$1,000",
      africa: "Largely unavailable",
      ukusa: "$6,000–$12,000",
    },
  ],
};

const IVFFertilityPage = () => {
  return <TreatmentTemplate treatment={IVF_TREATMENT} paxgrowData={IVF_PAXGROW} />;
};

export default IVFFertilityPage;